import React, { memo, useEffect, useState } from "react";
import Header from "../../layout/Header";
import { Link, useLocation } from "react-router-dom";
import { dashboardIconOne, dashboardIconTwo, dashboardIconThree, backIcon2 } from "../../../Image/Index";
import LineChartAnalyticalReport1 from "../../charts/LineChartAnalyticalReport1";
import BarChartAnalyticalReport1 from "../../charts/BarChartAnalyticalReport1";
import BarChartAnalyticalReport2 from "../../charts/BarChartAnalyticalReport2";
import DoughnutChartAnalyticalReport1 from "../../charts/DoughnutChartAnalyticalReport1";
import { getDasboardReport, getUserJourneyReport } from "../../../actions/dashboard";
import { decrypt } from "../../../utils/encodingdecoding";

const Dashboard = memo(({ }) => {
    const location = useLocation();
    const [FormData, setFormData] = useState({"errors":null,"totalCount":0,"message":"Success","data":{"totalCustomers":14746,"totalTransactionCount":73295,
        "Monthwisetrn_result": {
            "4-2023": "31753741",
            "3-2023": "708715127",
            "2-2023": "991600187",
            "1-2023": "1091293931",
            "12-2022": "1126547324",
            "11-2022": "1103449398",
            "10-2022": "1142555985",
            "9-2022": "770228680",
            "8-2022": "794629926",
            "7-2022": "793859284",
            "6-2022": "781460546",
            "5-2022": "789124447",
            "4-2022": "764396944",
            "3-2022": "815216355",
            "2-2022": "730358829",
            "1-2022": "818814120",
            "12-2021": "820733134",
            "11-2021": "796195069",
            "10-2021": "815852248",
            "9-2021": "790869482",
            "8-2021": "808597838",
            "7-2021": "822675739",
            "6-2021": "795575362",
            "5-2021": "822056289",
            "4-2021": "798654613",
            "3-2021": "819967038",
            "2-2021": "747704509",
            "1-2021": "816375358",
            "12-2020": "826058670",
            "11-2020": "792869299",
            "10-2020": "820248055",
            "9-2020": "793207870",
            "8-2020": "816779482",
            "7-2020": "821551168",
            "6-2020": "790715281",
            "5-2020": "823755891",
            "4-2020": "343590609"
        },
        "monthWiseTransactionCount":[{"monthyear":"1-2023","TotalTransactionCount":4157},{"monthyear":"2-2023","TotalTransactionCount":3345},{"monthyear":"3-2023","TotalTransactionCount":3408},{"monthyear":"4-2023","TotalTransactionCount":2789},{"monthyear":"5-2023","TotalTransactionCount":2916},{"monthyear":"6-2023","TotalTransactionCount":1090},{"monthyear":"7-2023","TotalTransactionCount":5439},{"monthyear":"8-2023","TotalTransactionCount":3277},{"monthyear":"9-2023","TotalTransactionCount":3278},{"monthyear":"10-2023","TotalTransactionCount":3196},{"monthyear":"11-2023","TotalTransactionCount":2985},{"monthyear":"12-2023","TotalTransactionCount":2850},{"monthyear":"1-2024","TotalTransactionCount":2809},{"monthyear":"2-2024","TotalTransactionCount":1303},{"monthyear":"3-2024","TotalTransactionCount":3555},{"monthyear":"4-2024","TotalTransactionCount":990},{"monthyear":"5-2024","TotalTransactionCount":5832},{"monthyear":"6-2024","TotalTransactionCount":2678},{"monthyear":"7-2024","TotalTransactionCount":2957},{"monthyear":"8-2024","TotalTransactionCount":2615},{"monthyear":"9-2024","TotalTransactionCount":2510},{"monthyear":"10-2024","TotalTransactionCount":2105},{"monthyear":"11-2024","TotalTransactionCount":502},{"monthyear":"12-2024","TotalTransactionCount":1616},{"monthyear":"1-2025","TotalTransactionCount":1963},{"monthyear":"2-2025","TotalTransactionCount":1598},{"monthyear":"3-2025","TotalTransactionCount":555},{"TotalTransactionCount":977}]},
       
        "ListData":null}
    );
    const [year, setYear] = useState({});
    const [years, setYears] = useState({});
    const [Report1, setReport1] = useState([]);
    const [Report2, setReport2] = useState([]);
    const [loader, setLoader] = useState(false);
    const [firstRender, setFirstRender] = useState(true);
    const Id = localStorage.getItem("Id");
    const dataID = decrypt(Id)

    // const fetch = async () => {
    //     setLoader(true);
    //     const token = JSON.parse(localStorage.getItem("token_gen"));
    //         await getDasboardReport(token?.access_token, Id).then((res) => {
    //             setFormData(res);
    //         }).catch((err) => {

    //         })
       

    //     setFirstRender(false);
    //     setLoader(false);
    // };
    // useEffect(() => {
    //     fetch();
    // }, []);
console.log(FormData)

    useEffect(() => {
            if (FormData?.data?.monthWiseTransactionCount) {
                const years = Array.from(
                    new Set(FormData.data.monthWiseTransactionCount.map((item) => item.monthyear?.split("-")[1]))
                );
                setYear(years.sort((a, b) => b - a));
                console.log(years.sort((a, b) => b - a))
                console.log(FormData.data.monthWiseTransactionCount)
                filterDatas(years[0], FormData.data.monthWiseTransactionCount).then((res) => {
                    setReport1(res);
                });
            }
 
        // else {
        //     setReport1(Object.values(Dashboard.MonthwiseTransaction));
        // }
    }, [FormData]);
    console.log(Report1)
console.log(year)
    useEffect(() => {
        if (FormData?.data?.Monthwisetrn_result) {
            const asArray = Object.entries(FormData?.data?.Monthwisetrn_result).map((arr) => {
                const data = arr[0];
                return data?.split("-")[1];
            });
            function onlyUnique(value, index, array) {
                return array.indexOf(value) === index;
            }
            var uniques = asArray.filter(onlyUnique);
            setYears(uniques.sort().reverse());
            filterData(uniques[0], FormData?.data?.Monthwisetrn_result).then((res) => {
                setReport2(res);
            });
        }
        // else {
        //     setReport2(Object.values(Dashboard.MonthwiseTransaction));
        // }
    }, [FormData]);

    const filterData = async (data, object) => {
        if (FormData?.data?.Monthwisetrn_result) {
        const asArray = await Object?.entries(object);
        let filtered = await asArray?.filter(([key, value]) => key?.split("-")[1] === data);
        let years = filtered[0];
        if (years && years[0]) {
            years = years[0]?.split("-")[1];
        }

        let allMonths = Array.from({ length: 12 }, (_, i) => i + 1);
        let mergedArray = allMonths.map((month) => {
            let matchingData = filtered.find((d) => parseInt(d[0]?.split("-")[0]) == month);
            return matchingData ? matchingData : [`${month}-${years}`, 0];
        });

        const n = mergedArray.length;
        for (let i = 0; i < n - 1; i++) {
            for (let j = 0; j < n - i - 1; j++) {
                const monthA = parseInt(mergedArray[j][0]?.split("-")[0]);
                const monthB = parseInt(mergedArray[j + 1][0]?.split("-")[0]);
                if (monthA > monthB) {
                    const temp = mergedArray[j];
                    mergedArray[j] = mergedArray[j + 1];
                    mergedArray[j + 1] = temp;
                }
            }
        }
        const tempdata = await mergedArray.map((arr) => {
            return arr[1];
        });
        return tempdata;
    }
    };
    const handleSelectChange = async (data, arr, type) => {
        filterData(data, arr).then((res) => {
            if (type) setReport1(res);
            else setReport2(res);
        });
    };
    const handleSelectChanges = async (data, arr, type) => {
        filterDatas(data, arr).then((res) => {
            if (type) setReport1(res);
            else setReport2(res);
        });
    };
    const filterDatas = async (selectedYear, data) => {
        const groupedData = data.reduce((acc, item) => {
            const { monthyear, TotalTransactionCount } = item;
            acc[monthyear] = (acc[monthyear] || 0) + TotalTransactionCount;
            return acc;
        }, {});
        const allMonths = Array.from({ length: 12 }, (_, i) => i + 1);
        const result = allMonths.map((month) => {
            const key = `${month}-${selectedYear}`;
            return groupedData[key] || 0; 
        });
    
        return result;
      
    };
const AgeWise = {
    "18-20": 27523,
    "21-30": 285847,
    "31-40": 285923,
    "41-50": 267839,
    "51-60": 181415,
    "61-70": 0,
    "71-80": 0,
    "81-90": 0
}
    return (
        <>
            <Header name={`${FormData[0]?.datastatus ? FormData[0]?.datastatus : ""}Dashboard`} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className="analyticalReport">
                <div className="analyticalReportRFMAnalysis">
                    <div className="analyticalReportRFMAnalysis__topSection">
                        <div className="container">
                            <div className="analyticalReportRFMAnalysis__leftSection">
                                <div className="dashboard__headingBackLink dashboard__headingBackLink2">
                                    {location?.state?.prevPath && (
                                        <Link to={"/upload-existing-data"}>
                                            <img style={{ width: "18px" }} src={backIcon2} alt="" />
                                            <span>Back</span>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="analyticalReportChartAnalysisOne">
                    <div id="dashboard" className="container">
                        <div className="analyticalReportChartAnalysisOne__bottomSection">
                            <div className="analyticalReportChartAnalysisOne__heading">
                                <h2>Customer Spending Overview</h2>
                            </div>
                            <div className="analyticalReportChartAnalysisOne__leftSection">
                                <div className="analyticalReportChartAnalysisOne__box">
                                    <div className="analyticalReportChartAnalysisOne__header">
                                        <div className="analyticalReportChartAnalysisOne__left">
                                            <div className="analyticalReportChartAnalysisOne__image">
                                                <img src={dashboardIconThree} alt="" />
                                            </div>
                                            <div className="analyticalReportChartAnalysisOne__details">
                                                <h3> Customers</h3>
                                            </div>
                                        </div>
                                    </div>

                                        <div className="analyticalReportChartAnalysisOne__reportSection">
                                        <h3>{ FormData?.data?.totalCustomers}</h3>
                                    </div>
                                 
                                 
                                </div>

                                <div className="analyticalReportChartAnalysisOne__box">
                                    <div className="analyticalReportChartAnalysisOne__header">
                                        <div className="analyticalReportChartAnalysisOne__left">
                                            <div className="analyticalReportChartAnalysisOne__image">
                                                <img src={dashboardIconThree} alt="" />
                                            </div>
                                            <div className="analyticalReportChartAnalysisOne__details">
                                                <h3>Transactions</h3>
                                            </div>
                                        </div>
                                        {/* <div className="analyticalReportChartAnalysisOne__right">
                                            <div className="analyticalReportChartAnalysisOne__button">
                                                <button className="btn btn-primary btn-sm">
                                                    <i className="fa-solid fa-plus"></i> Expand
                                                </button>
                                            </div>
                                        </div> */}
                                    </div>
                                 
                                        <div className="analyticalReportChartAnalysisOne__reportSection">
                                        <h3>{ FormData?.data?.totalTransactionCount}</h3>
                                    </div>
                                   
                               
                                </div>
                            
                                        <div className="analyticalReportChartAnalysisOne__box">
                                        <div className="analyticalReportChartAnalysisOne__header">
                                            <div className="analyticalReportChartAnalysisOne__left">
                                                <div className="analyticalReportChartAnalysisOne__image">
                                                    <img src={dashboardIconTwo} alt="" />
                                                </div>
                                                <div className="analyticalReportChartAnalysisOne__details">
                                                    <h3>Customer Average Spend</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="analyticalReportChartAnalysisOne__reportSection">
                                        <h3>25020</h3>
                                        </div>
                                    </div>
                                   
                            
                            </div>
                            <div className="analyticalReportChartAnalysisOne__rightSection">
                                <div className="analyticalReportChartAnalysisOne__box">
                                    <div className="analyticalReportChartAnalysisOne__header">
                                        <div className="analyticalReportChartAnalysisOne__left">
                                            <div className="analyticalReportChartAnalysisOne__image">
                                                <img src={dashboardIconOne} alt="" />
                                            </div>
                                            <div className="analyticalReportChartAnalysisOne__details">
                                                <h3>Transactions Count</h3>
                                            </div>
                                        </div>
                                        <div className="analyticalReportChartAnalysisOne__right">
                                            <div className="analyticalReportChartAnalysisOne__select">
                          
                                                  <select className="form-control selectArrow" onChange={(event) => handleSelectChanges(event.target.value, FormData?.data?.monthWiseTransactionCount , 1)}>
                                                  {Array.isArray(year) &&
                                                      year?.map((opt) => (
                                                          <option key={opt} value={opt}>
                                                              {opt}
                                                          </option>
                                                      ))}
                                              </select>
                                             

                                            </div>
                                            {/* <div className="analyticalReportChartAnalysisOne__button">
                                                <button className="btn btn-primary btn-sm">
                                                    <i className="fa-solid fa-plus"></i> Expand
                                                </button>
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className="analyticalReportChartAnalysisOne__chartSection">
                                        <BarChartAnalyticalReport1 data={Report1} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="analyticalReportChartAnalysisOne__topSection">
                            <div className="analyticalReportChartAnalysisOne__heading">
                                <h2>Data Overview</h2>
                            </div>
                            <div className="analyticalReportChartAnalysisOne__fullSection">
                                <div className="analyticalReportChartAnalysisOne__box">
                                    <div className="analyticalReportChartAnalysisOne__header">
                                        <div className="analyticalReportChartAnalysisOne__left">
                                            <div className="analyticalReportChartAnalysisOne__image">
                                                <img src={dashboardIconOne} alt="" />
                                            </div>
                                            <div className="analyticalReportChartAnalysisOne__details">
                                                <h3>Transactions Amount</h3>
                                            </div>
                                        </div>
                                        <div className="analyticalReportChartAnalysisOne__right">
                                            <div className="analyticalReportChartAnalysisOne__select">
                                                <select className="form-control selectArrow" onChange={(event) => handleSelectChange(event.target.value, FormData?.data?.Monthwisetrn_result, 0)}>
                                                    {Array.isArray(years) > 0 &&
                                                        years?.map((opt) => (
                                                            <option key={opt} value={opt}>
                                                                {opt}
                                                            </option>
                                                        ))}
                                                </select>
                                            </div>
                                            {/* <div className="analyticalReportChartAnalysisOne__button">
                                                <button className="btn btn-primary btn-sm">
                                                    <i className="fa-solid fa-plus"></i> Expand
                                                </button>
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className="analyticalReportChartAnalysisOne__chartSection">
                                        <LineChartAnalyticalReport1 data={Report2} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="analyticalReportChartAnalysisTwo">
                    <div className="container">
                        <div className="analyticalReportChartAnalysisTwo__topSection">
                            <div className="analyticalReportChartAnalysisTwo__heading">{Object.values(FormData[0]?.AgeWise ? FormData[0]?.AgeWise : {}).filter((val) => val > 0).length > 0 && <h2>Customer Demographic</h2>}</div>
                      
                                <div className="analyticalReportChartAnalysisTwo__leftSection">
                                    <div className="analyticalReportChartAnalysisTwo__box">
                                        <div className="analyticalReportChartAnalysisTwo__header">
                                            <div className="analyticalReportChartAnalysisTwo__left">
                                                <div className="analyticalReportChartAnalysisTwo__image">
                                                    <img src={dashboardIconTwo} alt="" />
                                                </div>
                                                <div className="analyticalReportChartAnalysisTwo__details">
                                                    <h3>Age Bifurcation</h3>
                                                </div>
                                            </div>
                                            {/* <div className="analyticalReportChartAnalysisTwo__right">
                                            <div className="analyticalReportChartAnalysisTwo__button">
                                                <button className="btn btn-primary btn-sm">
                                                    <i className="fa-solid fa-plus"></i> Expand
                                                </button>
                                            </div>
                                        </div> */}
                                        </div>
                                        <div className="analyticalReportChartAnalysisTwo__chartSection">
                                            <BarChartAnalyticalReport2 data={AgeWise} />
                                        </div>
                                    </div>
                                </div>
                           
                        
                                <div className="analyticalReportChartAnalysisTwo__rightSection">
                                    <div className="analyticalReportChartAnalysisTwo__box">
                                        <div className="analyticalReportChartAnalysisTwo__header">
                                            <div className="analyticalReportChartAnalysisTwo__left">
                                                <div className="analyticalReportChartAnalysisTwo__image">
                                                    <img src={dashboardIconThree} alt="" />
                                                </div>
                                                <div className="analyticalReportChartAnalysisTwo__details">
                                                    <h3>Gender Bifurcation</h3>
                                                </div>
                                            </div>
                                            {/* <div className="analyticalReportChartAnalysisTwo__right">
                                            <div className="analyticalReportChartAnalysisTwo__button">
                                                <button className="btn btn-primary btn-sm">
                                                    <i className="fa-solid fa-plus"></i> Expand
                                                </button>
                                            </div>
                                        </div> */}
                                        </div>
                                        <div className="analyticalReportChartAnalysisTwo__chartSection">
                                            <DoughnutChartAnalyticalReport1 Total_Male={12140} Total_female={2071} Others={535} />
                                        </div>
                                    </div>
                                </div>
                          
                        </div>
                        <div className="analyticalReportChartAnalysisTwo__bottomSection">
                            {location?.state?.prevPath && (
                                <div className="analyticalReportChartAnalysisTwo__rightSection">
                                    <div className="analyticalReportChartAnalysisTwo__paragraph">
                                        <p>With the Help of AI and existing data, use Novus Loyalty to set up campaign to supercharge your growth.</p>
                                    </div>
                                    <div className="analyticalReportChartAnalysisTwo__buttonSection">
                                        <Link to="/business-goals-selection" className="btn btn-primary">
                                            Select Your Business Goals
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </Link>
                                        {/* <Link to="" className="btn btn-outline-primary">
                                        Contact Novus Support
                                        <i className="fa-solid fa-comment-dots"></i>
                                    </Link> */}
                                        <Link to="/campaign-selection" state={{ path: "/analytical-report" }} className="btn btn-link">
                                            Skip
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default Dashboard;
